"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classManager = require("./ClassManager");

var recompose_1 = require("recompose");

exports["default"] = recompose_1.compose(recompose_1.setDisplayName('withClassModifier'), recompose_1.withProps(function (_a) {
  var className = _a.className,
      classModifier = _a.classModifier,
      defaultClassName = _a.defaultClassName;
  return {
    className: classManager["default"].getComponentClassName(className, classModifier, defaultClassName)
  };
}));